import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Modal } from 'antd';
import { Table as DoodTable, TableContainer } from 'dood-react-components';

import { postActions } from '../../actions';
import { translator } from '../../helpers';
import { tableConstants } from '../../constants/table.constants';

const { confirm } = Modal;

class Table extends Component {
    constructor(props) {
        super(props);

        this.state = {
            posts: null,
            loading: false
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = options => {
        this.props.dispatch(postActions.table(options)).then(
            result => {
                this.setState({
                    posts: result,
                    pagination: result.pagination,
                    filters: result.filters,
                    loading: false
                });
            },
            error => {
                this.setState({ error });
            }
        );
    };

    handleTableChange = (pagination, filters, sorter) => {
        this.setState({ loading: true });

        this.loadData({
            ...this.state.posts.options,
            pagination: { ...pagination, current: pagination.current },
            sortField: sorter.columnKey,
            sortOrder: sorter.order,
            filters: filters
        });
    };

    handleActionClick = (action, data) => {
        switch (action) {
            case tableConstants.ACTION_REMOVE:
                confirm({
                    title: this.props.translate('modal.title.are_you_sure'),
                    okText: this.props.translate('label.yes'),
                    okType: 'danger',
                    cancelText: this.props.translate('label.no'),
                    onOk: () => {
                        return this.handleDelete(data.id);
                    }
                });
                break;
            default:
                break;
        }
    };

    handleDelete = id => {
        return new Promise((resolve, reject) => {
            this.props.dispatch(postActions.remove(id)).then(
                () => {
                    const data = this.state.posts.data.filter(post => post.id !== id);

                    this.setState(previousState => ({
                        posts: { ...previousState.posts, data }
                    }));

                    resolve();
                },
                error => {
                    this.setState({ error });

                    reject();
                }
            );
        });
    };

    render() {
        const { posts, loading } = this.state;

        let tableComponent = null;

        if (posts) {
            const { data, columns, filters, pagination } = posts;

            tableComponent = (
                <DoodTable
                    translate={this.props.translate}
                    loading={loading}
                    data={data}
                    columns={columns}
                    filters={filters}
                    pagination={pagination}
                    onActionClick={this.handleActionClick}
                    onTableChange={this.handleTableChange}
                />
            );
        }

        return (
            <TableContainer
                translate={this.props.translate}
                title={this.props.translate('title.posts')}
                tableComponent={tableComponent}
                error={this.state.error}
                createRoute='/posts/create'
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        translate: translator(state)
    };
};

export default connect(mapStateToProps)(Table);
